export default __webpack_public_path__ + "static/bannerPubli-PE-27967718bea0399a75601354f06ab5c3.png";